//
// TypedMetadataField
//
// Return a Field for a field based on type

import { observer } from 'mobx-react-lite'

import {
    BooleanMetadata,
    FieldpickerMetadata,
    ImageMetadata,
    TextlistMetadata,
    TextMetadata,
} from '../metadata'

export const TypedMetadataField = observer(function TypedMetadataField({
    name,
    field,
    component,
    record,
    worksheet,
    active_class,
    visited_gids,
}) {
    if (!field) {
        return null
    }
    let renderkey = record.gid + '.' + name

    const language = worksheet.language
    let value = field.is_localized ? field.value[language] : field.value

    const sharedAttributes = {
        name,
        field,
        value,
        language,
        component,
        renderkey,
    }

    switch (field.type) {
        case 'image':
            return <ImageMetadata {...sharedAttributes} />
        case 'fieldpicker':
            return <FieldpickerMetadata {...sharedAttributes} worksheet={worksheet} />
        case 'boolean':
            return <BooleanMetadata {...sharedAttributes} />
        case 'textlist':
            return <TextlistMetadata {...sharedAttributes} />
        case 'text':
        case 'textline':
        case 'number':
        case 'decimal':
        case 'code':
        default:
            return <TextMetadata {...sharedAttributes} />
    }
})
